import { Fragment, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import classnames from "classnames";
import { Box } from "../Box/index.js";
import { useBlobUrl, useIntersectionObserver } from "../hooks/index.js";
import { useStyles } from "./Avatar.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const Avatar_Avatar = (props)=>{
    const $ = c(28);
    const { variant: t0, withBadge, size: t1, children, loadPhoto, alt, src: url, intersectionObserverProps } = props;
    const variant = void 0 === t0 ? "circle" : t0;
    const size = void 0 === t1 ? "medium" : t1;
    const { classes } = useStyles();
    const { createUrl, revokeUrl } = useBlobUrl();
    const [isInView, setIsInView] = useState(false);
    let t2;
    if ($[0] !== intersectionObserverProps) {
        t2 = _object_spread({
            rootMargin: "100px"
        }, intersectionObserverProps);
        $[0] = intersectionObserverProps;
        $[1] = t2;
    } else t2 = $[1];
    const [ref, entry] = useIntersectionObserver(t2);
    let t3;
    if ($[2] !== (null == entry ? void 0 : entry.isIntersecting)) {
        t3 = ()=>{
            if (null == entry ? void 0 : entry.isIntersecting) setIsInView(true);
        };
        $[2] = null == entry ? void 0 : entry.isIntersecting;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = null == entry ? void 0 : entry.isIntersecting;
    let t5;
    if ($[4] !== t4) {
        t5 = [
            t4
        ];
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    useEffect(t3, t5);
    const [src, setSrc] = useState(url);
    let t6;
    let t7;
    if ($[6] !== revokeUrl || $[7] !== url) {
        t6 = ()=>{
            setSrc(url);
            if (url) revokeUrl();
        };
        t7 = [
            url,
            revokeUrl
        ];
        $[6] = revokeUrl;
        $[7] = url;
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    useEffect(t6, t7);
    let t8;
    let t9;
    if ($[10] !== createUrl || $[11] !== isInView || $[12] !== loadPhoto || $[13] !== src) {
        t8 = ()=>{
            let isCancelled = false;
            if (!src && isInView) null == loadPhoto || loadPhoto().then((blob)=>{
                if (!isCancelled) setSrc(createUrl(blob));
            }).catch(_temp);
            return ()=>{
                isCancelled = true;
            };
        };
        t9 = [
            loadPhoto,
            src,
            isInView,
            createUrl
        ];
        $[10] = createUrl;
        $[11] = isInView;
        $[12] = loadPhoto;
        $[13] = src;
        $[14] = t8;
        $[15] = t9;
    } else {
        t8 = $[14];
        t9 = $[15];
    }
    useEffect(t8, t9);
    let t10;
    if ($[16] !== alt || $[17] !== children || $[18] !== classes || $[19] !== size || $[20] !== src || $[21] !== variant || $[22] !== withBadge) {
        t10 = withBadge ? /*#__PURE__*/ jsx(Badge, {
            className: `aqa_avatar_badge ${classes.badge}`,
            overlap: "circular",
            variant: "dot",
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "right"
            },
            children: /*#__PURE__*/ jsx(Avatar_Avatar, {
                className: classnames("aqa_avatar", "square" === variant && classes.avatarSquare),
                alt: alt,
                children: children,
                src: src,
                size: size
            })
        }) : /*#__PURE__*/ jsx(Avatar, {
            src: src,
            alt: alt,
            children: src ? /*#__PURE__*/ jsx(Fragment, {}) : children,
            "data-testid": "avatar",
            className: classnames("aqa_avatar", classes.avatar, classes[size], "square" === variant && classes.avatarSquare)
        });
        $[16] = alt;
        $[17] = children;
        $[18] = classes;
        $[19] = size;
        $[20] = src;
        $[21] = variant;
        $[22] = withBadge;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== classes.wrapper || $[25] !== ref || $[26] !== t10) {
        t11 = /*#__PURE__*/ jsx(Box, {
            ref: ref,
            component: "span",
            className: classes.wrapper,
            display: "inline-flex",
            flexShrink: 0,
            position: "relative",
            children: t10
        });
        $[24] = classes.wrapper;
        $[25] = ref;
        $[26] = t10;
        $[27] = t11;
    } else t11 = $[27];
    return t11;
};
function _temp() {}
export { Avatar_Avatar as Avatar };
